import { createContext, useContext } from 'react'
import { type QuizData, type QuizQuestionData } from '@terros/common'

export type QuizContextType = {
  quiz: QuizData
  questions: QuizQuestionData[]
  refetch: VoidFunction
  isFetching: boolean
}

export const QuizContext = createContext<QuizContextType | null>(null)

export const useQuizContext = (): QuizContextType => {
  const context = useContext(QuizContext)
  if (!context) {
    throw new Error('useQuizContext must be used within a QuizContextProvider')
  }
  return context
}
